<template>
  <div class="row">

    <div class="col-md-12">
      <h3 class="title">Page</h3>
      <div class="text-center" v-loading="loading" :element-loading-text="$t('loading_template') + '...'"></div>
    </div>

    <div class="col-md-12 card" v-if="allCategories.length > 0">
      <!-- first -->
      <div class="card-body row mb-4">
         <div class="col-md-12">

           <div class="form-group">
              <label>{{ $t("post_template_name") }}</label>
              <input type="text" v-model="form.contentName" class="form-control" disabled :placeholder="$t('post_template_name')">
           </div>

          <fg-input>
            <el-select size="large" filterable v-model="form.language_ID" :placeholder="$t('select_language')">
              <el-option
                class="select-default"
                v-for="lang in Languages"
                :key="lang.id"
                :label="lang.name"
                :value="lang.id"
              ></el-option>
            </el-select>
          </fg-input>

          <fg-input>
              <el-select size="large" v-model="form.ngo_ID" filterable :placeholder="$t('select_user_ngo')">
                   <el-option
                   class="select-default"
                   v-for="ngo in NGO"
                   :key="ngo.id"
                   :label="ngo.name"
                   :value="ngo.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input>
              <el-select size="large" v-model="form.location_ID" filterable :placeholder="$t('select_user_country')">
                   <el-option
                   class="select-default"
                   v-for="country in Countries"
                   :key="country.id"
                   :label="country.name"
                   :value="country.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input>
            <el-select size="large" multiple filterable v-model="form.categories" :placeholder="$t('select_ngos_and_country')">
              <el-button @click="checkAllContent" style="width:100%; border:none">{{ $t('select_all') }}</el-button>
                <el-option-group
                  v-for="group in allCategories"
                  :key="group.id"
                  :label="group.name"
                  class="select-default">
                  <el-option
                    v-for="item in group.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-option-group>
            </el-select>
          </fg-input>
         </div>

      </div>
    </div>

    <div class="col-md-12 card">
      <!-- second -->
      <div class="card-body row">
        <div class="col-md-12">

          <div class="form-group">
            <label for="name">{{ $t('page_title') }}</label>
            <input
              class="form-control"
              v-model="pageDetails.title"
              type="text"
              :placeholder="$t('enter_title')"
            />

            <div class="next-page">
              {{ $t('is_it_the_crown_page')}}
              <p-switch
                type="primary"
                v-model="isCrownPage"
                :on-text="$t('yes')"
                :off-text="$t('no')"
              ></p-switch>
            </div>
          </div>

          <div>
            <label for="backgroundImage">{{ $t('background_image')}}</label>
            <input
              id="backgroundImage"
              class="form-control"
              type="file"
              @change="setPageImage($event, 'backgroundImage')"
              placeholder
            />
            <img
              v-if="pageDetails.backgroundImage !== ''"
              :src="pageDetails.backgroundImage"
              alt=""
              style="width:40px; height:40px"
            />
          </div>
          <div>
            <label for="titleIcon">{{ $t('title_icon') }}</label>
            <input
              id="titleIcon"
              class="form-control"
              type="file"
              @change="setPageImage($event, 'titleIcon')"
              placeholder
            />
            <img
              v-if="pageDetails.titleIcon !==''"
              :src="pageDetails.titleIcon"
              alt=""
              style="width:40px; height:40px"
            />
          </div>
          <div style="display: none">
            <label for="leftBottomLogo">{{ $t('bottom_left_image') }}</label>
            <input
              id="leftBottomLogo"
              class="form-control"
              type="file"
              @change="setPageImage($event, 'leftBottomLogo')"
              placeholder
            />
            <img
              v-if="pageDetails.leftBottomLogo !==''"
              :src="pageDetails.leftBottomLogo"
              alt=""
              style="width:40px; height:40px"
            />
          </div>
          <div>
            <label for="rightBottomLogo">{{ $t('bottom_right_image') }}</label>
            <input
              id="rightBottomLogo"
              class="form-control"
              type="file"
              @change="setPageImage($event, 'rightBottomLogo')"
              placeholder
            />
            <img
              v-if="pageDetails.rightBottomLogo !==''"
              :src="pageDetails.rightBottomLogo"
              alt=""
              style="width:40px; height:40px"
            />
          </div>
          <div class="next-page">
            <span>
             {{ $t('is_it_the_parent_page') }}
              <p-switch
                type="primary"
                v-model="pageDetails.isItParent"
                :on-text="$t('yes')"
                :off-text="$t('no')"
              ></p-switch>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 card">
      <div class="card-body row">
        <div
          class="col-lg-12 col-md-12"
          v-for="(element, index) in answers"
          :key="index"
        >
          <p>
            <fg-input v-if="element.Question.type === 'categories'">
              <el-select
                size="large"
                class="select-primary"
                multiple
                filterable
                clearable
                v-model="element.Answer"
                :placeholder="$t('select_categories')"
              >
                <el-option
                  class="select-primary"
                  v-for="category in categories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id"
                ></el-option>
              </el-select>
            </fg-input>
          </p>

          <div class="form-group" v-if="element.Question.type === 'text'">
            <label for="">{{ element.Question.title }}</label>
            <input
              :key="'input_text_' + index"
              type="text"
              class="form-control"
              v-model="element.Answer"
            />
          </div>

          <fg-input
            v-if="element.Question.type === 'dropdown'"
            :label="element.Question.title"
          >
            <el-select
              size="large"
              class="select-primary"
              v-model="element.Answer"
              filterable
              clearable
              :placeholder="element.Question.title"
            >
              <el-option
                class="select-primary"
                v-for="item in element.Question.choices"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-option>
            </el-select>
          </fg-input>

          <!-- <textarea
            v-if="element.Question.type === 'editor'"
            v-model="element.Answer"
            name=""
            id=""
            cols="30"
            rows="10"
          ></textarea> -->

          <vue-editor
            v-if="element.Question.type === 'editor'"
            v-model="element.Answer"
          />

            <div v-if="element.Question.type === 'editor'">
              <div class="next-page">
                {{ $t('is_it_the_first_page') }}
                <p-switch
                  type="primary"
                  v-model="isFirstPage"
                  :on-text="$t('yes')"
                  :off-text="$t('no')"
                ></p-switch>
              </div>
              <div class="form-group" v-if="!isFirstPage">
                <label :for="'gridPageId_' + index">{{ $t('previous_page') }}</label>
                <el-select
                v-model="prevPageId"
                :placeholder="$t('select_previous_page')"
              >
                <el-option
                  class="select-default select-page-id"
                  v-for="(item, i) in pageOptions"
                  :key="i"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>

              </div>

              <div class="next-page">
                {{ $t('is_it_the_last_page') }}
                <p-switch
                  type="primary"
                  v-model="isLastPage"
                  :on-text="$t('yes')"
                  :off-text="$t('no')"
                ></p-switch>
              </div>
              <div class="form-group" v-if="!isLastPage">
                <label :for="'gridPageId_' + index">{{ $t('next_page') }}</label>
                <el-select
                v-model="nextPageId"
                :placeholder="$t('select_next_page')"
              >
                <el-option
                  class="select-default select-page-id"
                  v-for="(item, i) in pageOptions"
                  :key="i"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
              </div>
            </div>

          <div v-if="element.Question.type === 'file'">
            <label :for="'file_' + index">{{ element.Question.title }}</label>
            <input
              :id="'file_' + index"
              :key="'file_key_' + index"
              class="form-control"
              type="file"
              @change="setImage($event, element.Question.name)"
              placeholder
            />
          </div>

          <div v-if="element.Question.type === 'file'">
            <img
              v-if="element.Answer !==''"
              :src="element.Answer"
              alt=""
              style="width:40px; height:40px"
              :key="index"
            />
          </div>
        </div>

        <div class="col-lg-12 col-md-12">
          <!-- <div v-for="(grid, index) in gridsElement" :key="index"> -->
          <div v-for="(grid, index) in grids.elements" :key="index">
            <div
              v-if="grids.type === 'grid'"
              :unique-id="index"
              :key="'grid_container_' + index"
            >
              <fieldset class="border p-2">
                <legend class="w-auto">{{ $t('grid') }} {{ index }}</legend>

                <div class="form-group">
                  <label :for="'gridTitle_' + index">{{ $t('title') }}</label>
                  <input
                    :id="'gridTitle_' + index"
                    :key="'gridTitle_key_' + index"
                    class="form-control"
                    type="text"
                    v-model="inputs[index].title"
                    placeholder
                  />
                </div>

                <!-- <div class="form-group" style="display: none">
                  <label :for="'gridURL_' + index">URL</label>
                  <input
                    :id="'gridURL_' + index"
                    :key="'gridURL_key_' + index"
                    class="form-control"
                    type="url"
                    v-model="inputs[index].url"
                    placeholder
                  />
                </div> -->
              </fieldset>

              <div class="form-group">
                <label :for="'gridPageId_' + index">{{ $t('page') }}</label>
                <el-select v-model="inputs[index].pageId" :id="'gridPageId_' + index" placeholder="Select page ID">
                    <el-option
                      class="select-default select-page-id"
                      v-for="(item, i) in pageOptions"
                      :key="i"
                      :label="item.title"
                      :value="item.id"
                    ></el-option>
                  </el-select>

                <!-- <input
                  :id="'gridPageId_' + index"
                  :key="'gridPageId_key_' + index"
                  class="form-control"
                  type="tel"
                  v-model="grid.pageId"
                  placeholder
                /> -->
              </div>

              <div class="form-group">
                <label :for="'gridSNumber_' + index">{{ $t('sort_number') }}</label>
                <input
                  :id="'gridSortNumber_' + index"
                  :key="'gridSortNumber_key_' + index"
                  class="form-control"
                  type="text"
                  v-model="inputs[index].sortNumber"
                  placeholder
                />
              </div>

              <label :for="'gridFile_' + index">{{ $t('image_icon') }}</label>
              <input
                type="file"
                @change="setGridImage($event, index)"
                :id="'gridFile_' + index"
                :key="'gridFile_key_' + index"
                class="form-control"
              />
                <img
                   v-if="Object.keys(inputs[index].file).length > 0"
                  :src="inputs[index].file"
                  alt=""
                  style="width:40px; height:40px"
                  :key="index"
                />
              </div>

              <button
                @click="addGrid()"
                :key="'grid_add_btn_' + index"
                :id="'grid_add_btn_' + index"
                class="btn btn-info pull-right"
                v-show="index == grids.elements.length - 1"
              >
                +
              </button>
              <button
                @click="removeGrid(index)"
                :key="'grid_remove_btn_' + index"
                :id="'grid_remove_btn_' + index"
                class="btn btn-danger pull-right"
                v-show="index || (!index && grids.elements.length > 1)"
              >
                X
              </button>
            </div>
          </div>
          <button class="btn btn-info btn-block" @click="updatePage()"  v-loading="saving"
             element-loading-text="Updating data...">
            Update
          </button>
        </div>
    </div>

    </div>
  <!-- </div> -->
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import Modal from "src/components/UIComponents/Modal.vue";
import { Message } from "element-ui";

import { getToken } from "@/util/auth";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

import TextField from "@/components/UIComponents/TOL/TitleField.vue";
// import RichHtml from "@/components/UIComponents/TOL/RichHtml.vue";
import { VueEditor } from "vue2-editor";
// import TextareaField from "@/components/UIComponents/TOL/Textarea.vue";
import FileUpload from "@/components/UIComponents/TOL/FileUpload.vue";
// import SelectBox from "@/components/UIComponents/TOL/SelectBox.vue";
import Grid from "@/components/UIComponents/TOL/Grid.vue";

import Resource from "@/util/Api/resource.js";
const CategoryResource = new Resource("category");
const UserResource = new Resource("user");
const FileResource = new Resource("files");


import { fetchPageTemplate } from "@/util/Api/pageTemplate.js";
import { fetchPage } from "@/util/Api/page.js";
import { fetchPages } from "@/util/Api/page.js";
import { updatePage, getImage } from "@/util/Api/page.js";

export default {
  name: "PageComponent",
  components: {
    TextField,
    // RichHtml,
    VueEditor,
    // TextareaField,
    FileUpload,
    // SelectBox,
    Grid,
    PPagination,
    Modal,
    PSwitch
  },

  computed: {
  },

  data() {
    return {
      backgroundImage: null,
      rightBottomLogo: null,
      leftBottomLogo: null,
      modals: {
         classic: false
      },
      loading: false,
      saving:false,
      answers: null,
      searchQuery: "",
      propsToSearch: ["file_name"],
      pageOptions: [],
      postDetails: [],
      pageDetails: {
        postID: "",
        title: "",
        postTemplateID: "",
        isItParent: false,
        parentID: "",
        answers: [],
        backgroundImage: "",
        titleIcon: "",
        leftBottomLogo: "",
        rightBottomLogo: ""
      },
      files: [],

      pageTemplate: [],
      PageContent: {
        categories: []
      },
      grids: {
        type: "grid",
        elements: []
      },
      gridsElement: [],
      inputs: [],
      form: {
         language_ID:"",
         ngo_ID:"",
         location_ID:"",
         categories:[],
         contentName:"",
      },
      categories: [],
      users: [],
      counter: 0,
      pageTitle: "",
      isItParent: false,
      isLastPage: true,
      isFirstPage: true,
      nextPageId: null,
      prevPageId: null,
      isCrownPage: false,
      NGO:[],
      Countries:[],
      Languages:[],
      allCategories:[],
    };
  },

  created() {
    this.postDetails = this.$route.params.post;
    this.pageOptions = this.$route.params.pageOptions;

    if(this.postDetails.post) {
      this.form.contentName = this.postDetails.post.postTemplateName;
      this.form.language_ID = this.postDetails.post.language_Name.id;
      this.form.ngo_ID      = this.postDetails.post.ngoName.id;
      this.form.location_ID = this.postDetails.post.locationName.id;
      if(this.postDetails.post.categories.length > 0) {
        this.postDetails.post.categories.forEach(item => {
          this.form.categories.push(item.id);
        });
      }
    }

    if(this.postDetails.post.title.includes("|")){
       this.postDetails.post.title = this.postDetails.post.title.split("|")[1].trim();
    }

    let mainTitleSplited = this.postDetails.post.mainPostTitle;
    if(this.postDetails.post.mainPostTitle.includes("|")) {
      mainTitleSplited = this.postDetails.post.mainPostTitle.split("|")[1].trim();
    }

    //Split title and retrieve next and previous page IDs
    let navPages = mainTitleSplited.split("___");
    for (let i = 1; i <= (navPages.length-1); i++ ){
      if ( mainTitleSplited.split("___")[i] ){
        let values = mainTitleSplited.split("___")[i].split("-");
        if(values[0] == "nextPage"){
          this.isLastPage = false;
          this.nextPageId = values[1];
        }
        else if(values[0] == "prevPage") {
          this.isFirstPage = false;
          this.prevPageId = values[1];
        }
      }
    }

    if (navPages[0].split('--')[1] != undefined) {
      this.isCrownPage = true;
    }

    this.pageOptions.forEach((page, index) => {
      page.title = page.title.split('___')[0];
      if (+page.id === +this.prevPageId) {
        this.prevPageId = this.prevPageId + " | " + page.title
      }
      if (+page.id === +this.nextPageId) {
        this.nextPageId = this.nextPageId + " | " + page.title
      }
    });

    let tempTitle = this.postDetails.post.title.split("___")[0];

    if( this.isCrownPage === false ) {
      tempTitle = tempTitle.split('--')[0];
    }

    this.pageDetails.postID = this.postDetails.post.id;
    this.pageDetails.title = tempTitle;
    this.pageDetails.postTemplateID = this.postDetails.post.postTemplateID;
    this.pageDetails.isItParent = this.postDetails.post.isItParent;
    this.pageDetails.parentID = this.postDetails.post.parentID;
    this.pageDetails.backgroundImage = this.postDetails.post.backgroundImage;
    this.pageDetails.titleIcon = this.postDetails.post.titleIcon;
    this.pageDetails.leftBottomLogo = this.postDetails.post.leftBottomLogo;
    this.pageDetails.rightBottomLogo = this.postDetails.post.rightBottomLogo;
    this.pageDetails.answers = this.postDetails.postContent;

    this.answers = this.postDetails.postContent;

    // ADD UNICODE CHARACTER IF THE ANSWER IS THE CONTENT
    this.answers.forEach(answer => {
      if(answer.Question.type === 'editor')
        answer.Answer = unescape(JSON.parse(answer.Answer));
        // answer.Answer = answer.Answer.replace(/<p><br><\/p>/g, '')
        // answer.Answer = answer.Answer.replace(/<p><br><\/p><p><br><\/p>/g, '')
        if(answer.Answer.startsWith("<p>")){
          answer.Answer = answer.Answer.replace(/<p>/, '<<p>')
        }
    })

    this.pageDetails.answers.forEach((element) => {
       if(element.Question.type === 'editor'){
         element.Answer = element.Answer.slice(1,-1);
         element.Answer = element.Answer.replace(/\\/g,'');
       }
    });

    // this.pageDetails.answers.forEach(element => {
    //   if (element.Question.type === "grid") {
    //     this.grids = {
    //       type: "grid",
    //       elements: ["grid_0"]
    //     };
    //     return true;
    //   }
    // });

    this.getPageTemplate();
    this.getPage();
    this.getCategories();
  },
  methods: {

    onCopy() {
      this.showAlertMessage(this.$t("url_copied_to_clipboard"), "success");
      this.modals.classic = false;
    },

    onCopyError() {
      this.showAlertMessage(this.$t("failed_to_copy_url"), "error");
    },

    async setGridImage($event, index) {
      let file = $event.target.files[0];
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        if (file.size < 2097152) {
          this.inputs[index].file = await this.convertImage(file).catch(e =>
            Error(e)
          );
        } else {
          this.showAlertMessage(
            this.$t("image_size_too_large_image_size_cannot_be_more_than_2mb"),
            "error"
          );
        }
      } else {
        this.showAlertMessage(
          this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"),
          "error"
        );
      }
    },

    // Set selected image
    async setPageImage($event, fieldName) {
      let file = $event.target.files[0];
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        if (file.size < 2097152) {
          this.pageDetails[fieldName] = await this.convertImage(file).catch(e =>
            Error(e)
          );
        } else {
          this.showAlertMessage(
            this.$t("image_size_too_large_image_size_cannot_be_more_than_2mb"),
            "error"
          );
        }
      } else {
        this.pageDetails[fieldName] = "";
        this.showAlertMessage(
          this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"),
          "error"
        );
      }
    },

    // setting image from form
    async setImage($event, fieldName) {
      let file = $event.target.files[0];
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        if (file.size < 2097152) {
          this.form[fieldName] = file;
        } else {
          this.showAlertMessage(
            this.$t("image_size_too_large_image_size_cannot_be_more_than_2mb"),
            "error"
          );
        }
      } else {
        this.form[fieldName] = "";
        this.showAlertMessage(
          this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"),
          "error"
        );
      }
    },

    // convert image to base64
    convertImage(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          return resolve(reader.result);
        };
        reader.onerror = function(error) {
          return reject(error);
        };
      });
    },

    // get the template post is using with ID
    async getPageTemplate() {
      if (this.pageDetails.postTemplateID) {
        await fetchPageTemplate(this.pageDetails.postTemplateID)
          .then(response => {
            this.pageTemplate = response.data;

            this.pageTemplate.elements.forEach(element => {
              if (element.field.type === "grid") {
                // this.grids = {
                //   type: "grid",
                //   elements: []
                // };
                return true;
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    async getPage() {
      this.loading = true;
      await fetchPage(this.pageDetails.postID)
        .then(response => {
          this.pageTemplate = response.data;
          let elementGrid = response.data.postContent;

          if(elementGrid[0].Question.type === "grid"){
            let answers = JSON.parse(elementGrid[0].Answer);

            answers.forEach((answer, index) => {
              answer.file = answer.file ? answer.file:"";
              answer.pageId = answer.pageId ? answer.pageId :"";
              answer.sortNumber = answer.sortNumber ? answer.sortNumber:"";
              answer.title = answer.title ? answer.title: "";
              answer.type = answer.type ? answer.type: "grid";
              answer.url = answer.url ? answer.url:"";

              // this.gridsElement.push(answer);
              this.inputs.push(answer);

              this.grids.elements.push("grid_"+index);
            });
          }

          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    // adding new grid
    addGrid() {
      this.inputs.push({
        file:"",
        pageId: "",
        sortNumber:"",
        nextPageId:"",
        title: "",
        type: "grid",
        url: ""
      });

      this.grids.elements.push("grid_" + (this.grids.elements.length));
    },

    // removing grid
    removeGrid(index) {
      this.inputs.splice(index, 1);
      this.grids.elements.splice(index, 1);
    },

    // set crid
    setGrid(value, gridObject, valueKey) {
      const gridKey = gridObject.name; // grid_1 or grid_2
      const gridValueKey = valueKey; // value_1 or value_2

      if (this.form[gridKey])
        this.form[gridKey] = Object.assign(this.form[gridKey], {
          [gridValueKey]: value
        });
      else {
        this.form[gridKey] = { [gridValueKey]: value };
      }
    },

    // save page update
    async updatePage() {
      this.saving = true;
      let obj = [];
      let counterIndex = 0;

      this.inputs.forEach(element=>{
        if(typeof element.file !== 'string'){
           element.file = '';
        }
      });

      this.pageDetails.answers.forEach(element => {
        obj[counterIndex] = {
          id: element.QuestionID,
          fieldNumber: element.fieldNumber,
          type: element.Question.type,
          name: element.Question.name,
          answer: element.Question.type === "grid" ? this.inputs : element.Answer
        };
        counterIndex++;
      });

      if(this.isFirstPage){
        this.prevPageId = null;
      }
      if( this.isLastPage ) {
        this.nextPageId = null;
      }

      if(this.isFirstPage && this.isLastPage ) {
         this.pageDetails.title = this.pageDetails.title.split("___")[0];
      } else {
        if (this.prevPageId && String(this.prevPageId).includes("|")){
          this.prevPageId = this.prevPageId.split("|")[0].trim();
        }
        if (this.nextPageId && String(this.nextPageId).includes("|")){
          this.nextPageId = this.nextPageId.split("|")[0].trim();
        }

        if(this.pageDetails.title.split("___")[1]) {
          this.pageDetails.title = this.pageDetails.title.split("___")[0];
        }
        if (this.nextPageId !== null){
          this.pageDetails.title = this.pageDetails.title+"___" + "nextPage-" + this.nextPageId;
        }
        if (this.prevPageId !== null) {
          this.pageDetails.title = this.pageDetails.title+"___" + "prevPage-" + this.prevPageId;
        }
      }

      if(this.isCrownPage ) {
        this.pageDetails.title = "isCrown--"+this.pageDetails.title;
      }

      let formData = new FormData();
      formData.append("postID", this.pageDetails.postID);
      formData.append("title", this.pageDetails.title);
      formData.append("postTemplateID", this.pageDetails.postTemplateID);
      formData.append("backgroundImage", this.pageDetails.backgroundImage);
      formData.append("titleIcon", this.pageDetails.titleIcon);
      formData.append("leftBottomLogo", this.pageDetails.leftBottomLogo);
      formData.append("rightBottomLogo", this.pageDetails.rightBottomLogo);
      formData.append("isItParent", await this.pageDetails.isItParent);
      formData.append("answers", JSON.stringify(obj));

      if(this.form.ngo_ID !== undefined) {
         formData.append("ngo_ID", this.form.ngo_ID);
      }

      if(this.form.location_ID !== undefined) {
         formData.append("location_ID", this.form.location_ID);
      }

      if(this.form.language_ID !== undefined) {
         formData.append("language_ID", this.form.language_ID);
      }

      if(this.form.categories !== undefined) {
          let allCategory = this.form.categories;
          await allCategory.forEach(catID => {
            formData.append("categories[]", catID);
          });
      }

      // formData.forEach((value, key) => {
      //    console.log("key %s: value %s", key, value);
      // });

      await updatePage(formData)
        .then(response => {
          this.saving = false;
          this.showAlertMessage(this.$t("post_updated_successfully"), "success");
          this.$router.push({ name: "Pages" });
        })
        .catch(error => {
          this.saving = false;
          console.log(error);
        });
    },

    // Get all categories
    async getCategories() {
      await CategoryResource.list({})
      .then(response => {
        let categories = response.data;
        categories.forEach(element => {
          if(element.name.toLowerCase().includes("ngos")) {
             this.NGO = element.children;
             this.allCategories.push(element);
          } else if(element.name.toLowerCase().includes("countries")) {
             this.Countries = element.children;
             this.allCategories.push(element);
          } else if (element.name.toLowerCase().includes("languages")) {
             this.Languages = element.children;
          }
        });
      }).catch(error => {
        console.log('error', error)
      });
    },

    // Check All
    checkAllContent() {
       if(this.form.categories.length === 0) {
          this.allCategories.forEach(element => {
              element.children.forEach(item => {
                this.form.categories.push(item.id);
              });
          });
       } else {
         this.form.categories = [];
       }
    },

    setData(index) {},

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    }

  }
};
</script>
<style scoped>
.grid__unit {
  margin-bottom: 20px;
}
.el-select.select-primary.el-select--large {
  margin-top: 30px;
}
.next-page {
  padding-top: 20px;
  padding-bottom: 10px;
  font-size: 0.8571em;
  color: #9a9a9a;
}
</style>
